/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { chatListModelPagedResultSchema } from "../chatListModelPagedResultSchema.ts";
import { chatStatusEnumSchema } from "../chatStatusEnumSchema.ts";
import { z } from "zod";

export const getApiFeedbacksQueryParamsSchema = z.object({
    "Statuses": z.array(z.lazy(() => chatStatusEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - NotDefined</b>: </li>\n<li><b>1 - Opened</b>: Чат открыт</li>\n<li><b>2 - Closed</b>: Чат закрыт</li>\n</ul>\n")).describe("Фильтр по статусу обращения").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список чатов
 */
export const getApiFeedbacks200Schema = z.lazy(() => chatListModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiFeedbacks400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiFeedbacks401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiFeedbacks403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiFeedbacks500Schema = z.lazy(() => badResponseModelSchema)

export const getApiFeedbacksQueryResponseSchema = z.lazy(() => getApiFeedbacks200Schema)